import { Component, inject } from '@angular/core';
import { MasterDataStore } from '../services/master-data.store';

@Component({
  selector: 'app-copyright',
  imports: [],
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss'],
})
export class CopyrightComponent {
  private readonly masterDataStore = inject(MasterDataStore);

  getRegistrationNo(): string {
    return this.masterDataStore.getRegistrationNo();
  }
}
